import RoomContent from './RoomContent';

export default RoomContent;
